import { getTheme } from '@commons/utils/theme';

const theme = getTheme();

// Statuses returned as-is by /admin/cashiers/cashierFtpStatus — the API arbitrates the final
// status of a day (closing days and partial by-POS reporting included), the front only maps it
// to a color and a label.
export const ENUM_STATUS = {
  OK: 'ok',
  OK_NO_TURNOVER: 'ok_no_turnover',
  MISSING_FILE: 'missing_file',
  EMPTY_FILE: 'empty_file',
  MISSING_DATA: 'missing_data',
  NO_CHECK: 'no_check',
  NO_STORE_MAPPED: 'no_store_mapped',
  CLOSED: 'closed',
  UNAVAILABLE: 'unavailable',
  UNAUTHORIZED: 'unauthorized',
  FORBIDDEN: 'forbidden',
};

// Statuses the API considers fine: the only ones whose by-POS breakdown carries displayable
// values (an error/no-check day has no reliable per-POS detail to show or export).
export const OK_STATUSES = [ENUM_STATUS.OK, ENUM_STATUS.OK_NO_TURNOVER];

// Same color per status as the day cells (ColoredRound), reused for the status filter's dots.
export const getStatusColor = (status) => {
  switch (status) {
    case ENUM_STATUS.OK:
      return theme.colors.brand.primaryDarker;
    case ENUM_STATUS.OK_NO_TURNOVER:
      return theme.colors.infoOrange;

    case ENUM_STATUS.MISSING_FILE:
    case ENUM_STATUS.EMPTY_FILE:
    case ENUM_STATUS.MISSING_DATA:
    case ENUM_STATUS.UNAVAILABLE:
    case ENUM_STATUS.UNAUTHORIZED:
    case ENUM_STATUS.FORBIDDEN:
      return theme.colors.infoRed;

    case ENUM_STATUS.NO_CHECK:
      return theme.colors.dgrey;

    case ENUM_STATUS.NO_STORE_MAPPED:
      return theme.colors.infoBlue;

    case ENUM_STATUS.CLOSED:
      return theme.colors.infoLightOrange;

    default:
      return theme.colors.dgrey;
  }
};

// The status filter shows one entry per COLOR, not per raw API status: several statuses already
// share the same meaning/color (eg. every file/connection/data error is red), so listing all 11
// separately is just noise. Each group's color is derived from its first status, which is safe
// since getStatusColor already maps every status in a group to the same color.
export const STATUS_GROUPS = [
  {
    id: 'ok',
    statuses: [ENUM_STATUS.OK],
    labelKey: 'ADMIN.FTP_DEBUG.STATUS_OK',
    descriptionKey: 'ADMIN.FTP_DEBUG.STATUS_LEGEND_DESCRIPTION_OK',
  },
  {
    id: 'ok_no_turnover',
    statuses: [ENUM_STATUS.OK_NO_TURNOVER],
    labelKey: 'ADMIN.FTP_DEBUG.STATUS_OK_NO_TURNOVER',
    descriptionKey: 'ADMIN.FTP_DEBUG.STATUS_LEGEND_DESCRIPTION_OK_NO_TURNOVER',
  },
  {
    id: 'error',
    statuses: [
      ENUM_STATUS.MISSING_FILE,
      ENUM_STATUS.EMPTY_FILE,
      ENUM_STATUS.MISSING_DATA,
      ENUM_STATUS.UNAVAILABLE,
      ENUM_STATUS.UNAUTHORIZED,
      ENUM_STATUS.FORBIDDEN,
    ],
    labelKey: 'ADMIN.FTP_DEBUG.STATUS_GROUP_ERROR',
    descriptionKey: 'ADMIN.FTP_DEBUG.STATUS_LEGEND_DESCRIPTION_ERROR',
  },
  {
    id: 'no_check',
    statuses: [ENUM_STATUS.NO_CHECK],
    labelKey: 'ADMIN.FTP_DEBUG.STATUS_NO_CHECK',
    descriptionKey: 'ADMIN.FTP_DEBUG.STATUS_LEGEND_DESCRIPTION_NO_CHECK',
  },
  {
    id: 'no_store_mapped',
    statuses: [ENUM_STATUS.NO_STORE_MAPPED],
    labelKey: 'ADMIN.FTP_DEBUG.STATUS_NO_STORE_MAPPED',
    descriptionKey: 'ADMIN.FTP_DEBUG.STATUS_LEGEND_DESCRIPTION_NO_STORE_MAPPED',
  },
  {
    id: 'closed',
    statuses: [ENUM_STATUS.CLOSED],
    labelKey: 'ADMIN.FTP_DEBUG.STATUS_CLOSED',
    descriptionKey: 'ADMIN.FTP_DEBUG.STATUS_LEGEND_DESCRIPTION_CLOSED',
  },
];
